export const styles = theme => ({
    bottomBtn: {
		justifyContent: 'center',
		width: '100%',
		display: 'flex',
		[theme.breakpoints.between('xs', 'sm')]: {
			marginBottom: 35,
		},
		[theme.breakpoints.only( 'xs')]: {
			justifyContent: 'unset',
			width: '100%',
			display: 'block',
		},
		[theme.breakpoints.only( 'md')]: {
			marginBottom: 48
		},
    },
    uploadButton: {
		marginRight: theme.spacing(1),
		marginBottom: theme.spacing(2),
	},
	removeButton: {
		marginBottom: theme.spacing(2),
	},
    uploadButtons: {
		justifyContent: 'center',
		alignItems: 'center',
		paddingLeft: '0px',
		margin: 0,
		height: '100%',
		alignSelf: 'center',
		flexDirection:"column",
		'& div': {
			paddingLeft: '20px',
			paddingBottom: '10px',
			paddingTop: 0,
			'&:before': {
				display: 'none',
			},
			'& div': {
				padding: 0
			}
		}
	},
    customFileUpload: {
		cursor: 'pointer',
		'& div': {
			display: 'none'
		},
		'& input[type=file]': {
			display: 'none'
		}
	},
    imageWrapper: {
		// display: 'inline',
		[theme.breakpoints.between('xs', 'sm')]: {
			marginTop: '0',
		},
	},
    avatarImage: {
		textAlign: 'center',
		alignItems: 'center',
		justifyContent: 'center',
		'& div': {
			width: '100px',
			height: '100px',
			border: '1px solid #ddd',
			padding: '6px',
		}
	},
    imageGrid: {
		marginTop: theme.spacing(3),
		justifyContent:"center"
	},
});
  